import * as React from "react";
import {
  Box,
  Button,
  Container,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import HardwareCard from "../components/ui/HardwareCard";
import {
  hardwareHeader,
  HARDWARE_CARDS,
  hardwareCTA,
} from "../content/hardware";
import Section from "../components/ui/Section";
import DemoDialog from "../components/ui/DemoDialog";

export default function Devices() {
  const [openDemo, setOpenDemo] = React.useState(false);

  return (
    <Box sx={{ bgcolor: "grey.50" }}>
      <DemoDialog open={openDemo} onClose={() => setOpenDemo(false)} />

      <Section
        id="devices"
        bgcolor="transparent"
        header={{
          title: hardwareHeader.title,
          subtitle: (
            <>
              {hardwareHeader.subtitle}{" "}
              <Link
                href={hardwareHeader.storeUrl}
                target="_blank"
                rel="noopener"
              >
                {hardwareHeader.storeLabel}
              </Link>
              .
            </>
          ),
        }}
      >
        {/* البطاقات */}
        <Grid container spacing={3}>
          {HARDWARE_CARDS.map((card, idx) => (
            <Grid key={idx} size={{ xs: 12, md: 6, lg: 4 }}>
              <HardwareCard {...card} />
            </Grid>
          ))}
        </Grid>

        {/* شريط CTA السفلي */}
        <Container disableGutters sx={{ mt: { xs: 4, md: 6 } }}>
          <Paper
            elevation={0}
            sx={(theme) => ({
              p: { xs: 2.5, md: 3 },
              px: { xs: 3, md: 4 },
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              color: "primary.contrastText",
              background: `linear-gradient(90deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
            })}
          >
            <Stack spacing={0.5}>
              <Typography
                sx={{ fontWeight: 900, fontSize: { xs: 18, md: 20 } }}
              >
                {hardwareCTA.title}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.95 }}>
                {hardwareCTA.subtitle}
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="warning"
              onClick={() => setOpenDemo(true)}
              sx={{ fontWeight: 900, px: 6 }}
            >
              {hardwareCTA.primaryLabel}
            </Button>
          </Paper>
        </Container>
      </Section>
    </Box>
  );
}
